<template>
  <div v-if="hasAnyFloatingButton" class="menu-wrapper">
    <a v-if="showContactSupportButton" :href="session.phone_contact_url"
       class="menu-btn contact-support" :class="{'cb-enabled': showChatbot}"
       @click.stop="openSupportContactUrl()"
    >
      <img :src="require('@/assets/images/contact-support-icon.svg')" class="icon" />
      <span>Contact Support: </span>
      <strong>{{ supportPhone }}</strong>
    </a>

    <div class="chatbot-wrapper" v-if="showChatbot">
      <Chatbot v-if="enableChatbot" @close="toggleChatbot()" v-click-outside="toggleChatbot" />
      <div class="menu-btn chatbot" @click.stop="toggleChatbot()">
        <img v-if="enableChatbot" :src="require('@/assets/images/chat-close.svg')" class="icon" />
        <img v-else :src="require('@/assets/images/chat.svg')" class="icon" />
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import { InputType } from '@/constants'
import Chatbot from '@/components/Chatbot'

export default {
  name: 'FloatingButtons',
  components: {Chatbot},
  props: {
    isFAQ: Boolean
  },
  data: function() {
    return {
      enableChatbot: false,
      boxShadow: ''
    }
  },
  watch: {
    'session': function(to, from) {
      this.setBoxShadow()
    }
  },
  computed: {
    ...mapState(['session', 'showChatbotHeader']),
    ...mapGetters(['isMainMenu', 'isSessionUserKnown']),
    showChatbot: function() {
      return this.session && this.session.show_chatbot && (this.isMainMenu || this.isFAQs) && !this.showChatbotHeader
    },
    showContactSupportButton() {
      return this.session && this.isMainMenu && this.session.show_phone_link && this.session.phone_contact_url
    },
    hasAnyFloatingButton: function() {
      return this.showContactSupportButton || this.showChatbot
    },
    supportPhone: function() {
      if (this.showContactSupportButton) {
        const pos = this.session.phone_contact_url[4] === '+' ? 5 : 4
        return this.session.phone_contact_url.slice(pos)
      }
      return ''
    },
    isFAQs: function() {
      return this.session && this.session.step_type === InputType.Faqs
    }
  },
  methods: {
    toggleChatbot: function() {
      this.enableChatbot = !this.enableChatbot
    },
    openSupportContactUrl: function() {
      window.location = this.session.phone_contact_url
    },
    setBoxShadow: function() {
      document.addEventListener('DOMContentLoaded', function() {
        const rootStyles = getComputedStyle(document.documentElement)
        const themeColor = rootStyles.getPropertyValue('--theme_color').trim()
        const hex = themeColor.replace('#', '')
        const r = parseInt(hex.substring(0, 2), 16)
        const g = parseInt(hex.substring(2, 4), 16)
        const b = parseInt(hex.substring(4, 6), 16)
        const rgbaColor = `rgba(${r}, ${g}, ${b}, 0.14)`
        document.documentElement.style.setProperty('--box-shadow-color', rgbaColor)
      })
    }
  },
  beforeDestroy() {
    this.enableChatbot = false
    this.$root.$off('chat-ended')
  },
  created() {
    this.setBoxShadow()
    this.$root.$on('chat-ended', () => {
      this.enableChatbot = false
    })
  }
}
</script>

<style scoped lang="less">
  .menu-wrapper {
    gap: 16px;
    display: flex;
    position: fixed;
    right: 30px;
    bottom: 30px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    z-index: 11;

    .menu-btn {
      width: 60px;
      height: 60px;
      display: flex;
      cursor: pointer;
      background: #ffffff;
      align-items: center;
      border-radius: 60px;
      justify-content: center;
      padding: 14px 10px 10px;
      box-shadow: 0 1px 14px 7px rgba(0, 0, 0, 0.1);

      &.chatbot {
        position: relative;
        background: var(--theme_color);
        box-shadow: 0 1px 14px 7px var(--box-shadow-color);
      }

      &.contact-support {
        color: #5a5a5a;
        font-size: 18px;
        cursor: pointer;
        text-decoration: none;
        font-family: var(--font_family);

        &:hover {
          text-decoration: none;
          color: #4f4f4f;
        }

        span {
          font-weight: 400;
          font-size: 16px;
          line-height: 21.82px;
          color: #5a5a5a;
          margin-left: 10px;
          margin-right: 6px;
          display: none;
        }

        strong {
          font-weight: 700;
          font-size: 16px;
          line-height: 21.82px;
          color: #5a5a5a;
          display: none;
        }
      }

      .icon {
        width: 28px;
        height: 28px;
        user-select: none;
      }
    }

    @media only screen and (min-width: 768px) {
      .menu-btn {
        &.contact-support {
          width: auto;
          padding: 14px 18px;

          .icon {
            width: 23.48px;
            height: 23.85px;
          }
          span, strong {
            display: inline-block;
          }
        }
      }
    }
  }

</style>
